import { DynamicPermissionsType, RoleCode } from './types';

/**
 * Кол-во секунд для автоматической перезагрузки страницы,
 * если при выходе из приложения что-то пошло не так
 */
export const AUTO_RELOAD_PAGE_TIMER = 5000;

export const ROLE_PERMISSIONS_DEFAULT: Record<RoleCode, readonly string[]> = {
  SysOp: [
    // ----------PAGE----------
    'pageAdministrationViewing',
    'pageAssociationViewing',
    'pageAssociationOrganisationsViewing',
    'pageAssociationUsersViewing',
    'pageNewsFeedViewing',
    'pageChatsViewing',
    'pageChatsInnerViewing',
    'pageChatPublicViewing',
    'pageCommitteesViewing',
    'pageSubCommitteesViewing',
    'pageEventsViewing',
    'pageInfoViewing',
    'pageOrganisationViewing',
    'pagePollsViewing',
    'pageNewsletterViewing',
    'pageProfileViewing',
    'pageSettingsViewing',
    'pageSettingsPreferencesViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',
    'pageBirthdaysViewing',
    'pageCooperationChainsViewing',

    // ----------ASSOCIATION----------
    'associationCreating',
    'associationEditing',
    'associationChannelAutoSubscribing',

    // ----------CHATS----------
    'chatsCreating',
    'chatInviteMembersViewing',

    // ----------COMMITTEES----------
    'committeeCreating',
    'committeeDeleting',
    'committeeEditing',
    'committeeSpecialFieldsForAssociationEditing',

    'subCommitteeCreating',
    'subCommitteeDeleting',
    'subCommitteeEditing',
    'subCommitteeSpecialFieldsForAssociationViewing',
    'subCommitteeSpecialFieldsForAssociationEditing',

    'committeeChatsCreating',
    'committeeChatsEditing',

    'committeeMembersViewing',
    'committeeMembersAdding',
    'committeeMembersDeleting',
    'committeeConfigsViewing',

    // ----------EVENTS----------
    'eventCreating',
    'eventEditing',
    'eventReportViewing',
    'eventMembersViewing',
    'eventsAllViewing',

    'eventChatCreating',

    // ----------IMPORT----------
    'importViewing',

    // ----------ORGANISATIONS---------
    'organisationCreating',
    'organisationDeleting',
    'organisationEditing',
    'organisationSpecialFieldsViewing',
    'organisationSpecialFieldsEditing',
    'organisationSpecialFieldsForAssociationViewing',
    'organisationSpecialFieldsForAssociationEditing',
    'organisationConfigsViewing',

    'organisationChatsCreating',
    'organisationChatsEditing',

    'organisationEmployeeViewing',
    'organisationEmployeeCreating',
    'organisationEmployeeEditing',
    'organisationEmployeeDeleting',
    'organisationEmployeePhoneFieldViewing',
    'organisationEmployeeEmailFieldViewing',
    'organisationEmployeeEmailFieldEditing',
    'organisationEmployeeRoleFieldViewing',
    'organisationEmployeeSpecialFieldsViewing',
    'organisationEmployeeSpecialFieldsEditing',
    'organisationEmployeeSpecialFieldsForAssociationViewing',
    'organisationEmployeeSpecialFieldsForAssociationEditing',
    'organisationEmployeeJobTitleFieldsEditing',
    'organisationEmployeeJobTitlesForAdminOnlyEditing',

    // ----------POLLS----------
    'pollCreating',
    'pollEditing',
    'pollMembersViewing',
    'pollStatisticsViewing',
    'pollsAllViewing',

    // ----------NEWSLETTERS----------
    'newsletterCreating',
    'newsletterEditing',

    // ----------PREFERENCES----------
    'preferencesEditing',
    'preferenceShowOnlyLoyaltyProgramEditing',

    // ----------LOYALTY PROGRAM----------
    'loyaltyProgramCreating',
    'loyaltyProgramEditing',
    'loyaltyProgramDeleting',
    'loyaltyProgramPublishing',
    'loyaltyProgramUnpublishing',
    'loyaltyProgramOwnProductsViewing',
    'loyaltyProgramAllStatisticsViewing',
    'loyaltyProgramProductStatisticsViewing',
    'loyaltyProgramCollectionStatisticsViewing',
    'loyaltyProgramUnionListViewing',
    'loyaltyProgramDateExpirationFieldEditing',
    'loyaltyProgramSortOrderEditing',
    'loyaltyProgramProductCodesExport',
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramCollectionsViewing',
    'loyaltyProgramCollectionEditing',
    'loyaltyProgramCollectionDeleting',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestInfoViewing',
    'loyaltyProgramProductRequestEditing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramProductRequestDeleting',
    'loyaltyProgramOnlyYourProductRequestDeleting',

    // ----------GROUPS----------
    'synchronizeWithTelegram',

    // ----------CONTACTS----------
    'contactsTypeForAdminViewing',
    'contactsCreating',
    'contactsEditing',
    'contactsDeleting',
    'contactsRequireValueEditing',

    // ----------USERS LIST----------
    'usersListSortByEdited',

    // ----------USERS----------
    'userChatButtonViewing',
    'profileByPhoneSearching',
    'profileByEmailSearching',

    // ----------CURATOR----------
    'curatorButtonViewing',

    // ----------PAGES----------
    'pageCreating',
    'pageEditing',
    'pageDeleting',
  ],
  AdminUO: [
    // ----------PAGE----------
    'pageAdministrationViewing',
    'pageAssociationViewing',
    'pageAssociationOrganisationsViewing',
    'pageAssociationUsersViewing',
    'pageNewsFeedViewing',
    'pageChatsViewing',
    'pageChatsInnerViewing',
    'pageChatPublicViewing',
    'pageCommitteesViewing',
    'pageSubCommitteesViewing',
    'pageEventsViewing',
    'pageInfoViewing',
    'pageOrganisationViewing',
    'pagePollsViewing',
    'pageNewsletterViewing',
    'pageProfileViewing',
    'pageSettingsViewing',
    'pageSettingsPreferencesViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',
    'pageBirthdaysViewing',
    'pageCooperationChainsViewing',

    // ----------ASSOCIATION----------
    'associationEditing',
    'associationChannelAutoSubscribing',

    // ----------CHATS----------
    'chatsCreating',
    'chatInviteMembersViewing',

    // ----------COMMITTEES----------
    'committeeCreating',
    'committeeDeleting',
    'committeeEditing',
    'committeeSpecialFieldsForAssociationEditing',

    'subCommitteeCreating',
    'subCommitteeDeleting',
    'subCommitteeEditing',
    'subCommitteeSpecialFieldsForAssociationViewing',
    'subCommitteeSpecialFieldsForAssociationEditing',

    'committeeChatsCreating',
    'committeeChatsEditing',

    'committeeMembersViewing',
    'committeeMembersAdding',
    'committeeMembersDeleting',
    'committeeConfigsViewing',

    // ----------EVENTS----------
    'eventCreating',
    'eventEditing',
    'eventReportViewing',
    'eventMembersViewing',
    'eventsAllViewing',

    'eventChatCreating',

    // ----------IMPORT----------
    'importViewing',

    // ----------ORGANISATIONS----------
    'organisationCreating',
    'organisationDeleting',
    'organisationEditing',
    'organisationSpecialFieldsViewing',
    'organisationSpecialFieldsEditing',
    'organisationSpecialFieldsForAssociationViewing',
    'organisationSpecialFieldsForAssociationEditing',
    'organisationConfigsViewing',

    'organisationChatsCreating',
    'organisationChatsEditing',

    'organisationEmployeeViewing',
    'organisationEmployeeCreating',
    'organisationEmployeeEditing',
    'organisationEmployeeDeleting',
    'organisationEmployeePhoneFieldViewing',
    'organisationEmployeeEmailFieldViewing',
    'organisationEmployeeEmailFieldEditing',
    'organisationEmployeeRoleFieldViewing',
    'organisationEmployeeSpecialFieldsViewing',
    'organisationEmployeeSpecialFieldsEditing',
    'organisationEmployeeSpecialFieldsForAssociationViewing',
    'organisationEmployeeSpecialFieldsForAssociationEditing',
    'organisationEmployeeJobTitleFieldsEditing',
    'organisationEmployeeJobTitlesForAdminOnlyEditing',

    // ----------POLLS----------
    'pollCreating',
    'pollEditing',
    'pollMembersViewing',
    'pollStatisticsViewing',
    'pollsAllViewing',

    // ----------NEWSLETTERS----------
    'newsletterCreating',
    'newsletterEditing',

    // ----------PREFERENCES----------
    'preferencesEditing',

    // ----------LOYALTY PROGRAM----------
    'loyaltyProgramCreating',
    'loyaltyProgramEditing',
    'loyaltyProgramDeleting',
    'loyaltyProgramPublishing',
    'loyaltyProgramUnpublishing',
    'loyaltyProgramOwnProductsViewing',
    'loyaltyProgramAllStatisticsViewing',
    'loyaltyProgramProductStatisticsViewing',
    'loyaltyProgramCollectionStatisticsViewing',
    'loyaltyProgramUnionListViewing',
    'loyaltyProgramDateExpirationFieldEditing',
    'loyaltyProgramSortOrderEditing',
    'loyaltyProgramProductCodesExport',
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramCollectionsViewing',
    'loyaltyProgramCollectionEditing',
    'loyaltyProgramCollectionDeleting',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestInfoViewing',
    'loyaltyProgramProductRequestEditing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramProductRequestDeleting',
    'loyaltyProgramOnlyYourProductRequestDeleting',

    // ----------GROUPS----------
    'synchronizeWithTelegram',

    // ----------CONTACTS----------
    'contactsTypeForAdminViewing',
    'contactsCreating',
    'contactsEditing',
    'contactsDeleting',
    'contactsRequireValueEditing',

    // ----------USERS LIST----------
    'usersListSortByEdited',

    // ----------USERS----------
    'userChatButtonViewing',
    'profileByPhoneSearching',
    'profileByEmailSearching',

    // ----------CURATOR----------
    'curatorButtonViewing',

    // ----------PAGES----------
    'pageCreating',
    'pageEditing',
    'pageDeleting',
  ],
  AdminDO: [
    // ----------PAGE----------
    'pageAssociationViewing',
    'pageAssociationOrganisationsViewing',
    'pageAssociationUsersViewing',
    'pageNewsFeedViewing',
    'pageChatsViewing',
    'pageChatsInnerViewing',
    'pageChatPublicViewing',
    'pageCommitteesViewing',
    'pageSubCommitteesViewing',
    'pageEventsViewing',
    'pageInfoViewing',
    'pageOrganisationViewing',
    'pagePollsViewing',
    'pageNewsletterViewing',
    'pageProfileViewing',
    'pageSettingsViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',
    'pageBirthdaysViewing',
    'pageCooperationChainsViewing',

    // ----------ASSOCIATION----------
    'associationChannelAutoSubscribing',

    // ----------COMMITTEE----------
    'committeeMembersViewing',

    // ----------EVENTS----------
    // TODO: временное решение
    'eventCreating',
    'eventHideFieldsEditing',
    'eventMembersViewing',
    'onlyYourEventEditing',

    'eventChatCreating',

    // ----------ORGANISATIONS----------
    'onlyYourOrganisationEditing',
    'onlyYourOrganisationSpecialFieldsViewing',
    'onlyYourOrganisationSpecialFieldsEditing',
    'onlyYourOrganisationSpecialFieldsForAssociationViewing',

    'onlyYourOrganisationChatsCreating',
    'onlyYourOrganisationChatsEditing',

    'organisationEmployeeViewing',
    'onlyYourOrganisationEmployeeEditing',
    'onlyYourOrganisationEmployeeDeleting',
    'onlyYourOrganisationEmployeeSpecialFieldsViewing',
    'onlyYourOrganisationEmployeeSpecialFieldsEditing',
    'onlyYourOrganisationEmployeeJobTitleFieldsEditing',

    // ----------LOYALTY PROGRAM----------
    'loyaltyProgramCreating',
    'loyaltyProgramOwnProductsViewing',
    'loyaltyProgramUnionListViewing',
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramOnlyYourProductRequestDeleting',

    'loyaltyProgramOnlyYourProductStatisticsViewing',
    'loyaltyProgramOnlyYourOrganisationProductEditing',
    'loyaltyProgramOnlyYourOrganisationProductUnpublishing',
    'loyaltyProgramOnlyYourOrganisationProductCodesExport',

    // ----------CONTACTS----------
    'onlyYourOrganisationContactsCreating',
    'onlyYourOrganisationContactsEditing',
    'onlyYourOrganisationContactsDeleting',

    'onlyYourOrganisationEmployeeContactsCreating',
    'onlyYourOrganisationEmployeeContactsEditing',
    'onlyYourOrganisationEmployeeContactsDeleting',

    // ----------USERS LIST----------
    'usersListSortByEdited',

    // ----------USERS----------
    'onlyYourJobTitleFieldsEditing',

    'userChatButtonViewing',

    // ----------CURATOR----------
    'curatorButtonViewing',
  ],
  ParticipantUO: [
    // ----------PAGE----------
    'pageAssociationViewing',
    'pageAssociationOrganisationsViewing',
    'pageAssociationUsersViewing',
    'pageNewsFeedViewing',
    'pageChatsViewing',
    'pageChatsInnerViewing',
    'pageChatPublicViewing',
    'pageCommitteesViewing',
    'pageSubCommitteesViewing',
    'pageEventsViewing',
    'pageInfoViewing',
    'pageOrganisationViewing',
    'pagePollsViewing',
    'pageNewsletterViewing',
    'pageProfileViewing',
    'pageSettingsViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',
    'pageBirthdaysViewing',

    // ----------ASSOCIATION----------
    'associationChannelAutoSubscribing',

    // ----------COMMITTEE----------
    'committeeMembersViewing',

    // ----------EVENT----------
    'eventCreating',
    'eventMembersViewing',
    'onlyYourEventEditing',

    'eventChatCreating',

    // ----------ORGANISATION----------
    'organisationEmployeeViewing',

    // ----------LOYALTY PROGRAM----------
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramOnlyYourProductRequestDeleting',

    // ----------POLL----------
    'pollCreating',
    'onlyYourPollEditing',
    'onlyYourPollStatisticsViewing',

    // ----------USERS----------
    'onlyYourJobTitleFieldsEditing',

    'userChatButtonViewing',

    // ----------CURATOR----------
    'curatorButtonViewing',
  ],
  ParticipantDO: [
    // ----------PAGE----------
    'pageAssociationViewing',
    'pageAssociationOrganisationsViewing',
    'pageAssociationUsersViewing',
    'pageNewsFeedViewing',
    'pageChatsViewing',
    'pageChatsInnerViewing',
    'pageChatPublicViewing',
    'pageCommitteesViewing',
    'pageSubCommitteesViewing',
    'pageEventsViewing',
    'pageInfoViewing',
    'pageOrganisationViewing',
    'pagePollsViewing',
    'pageNewsletterViewing',
    'pageProfileViewing',
    'pageSettingsViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',
    'pageBirthdaysViewing',

    // ----------ASSOCIATION----------
    'associationChannelAutoSubscribing',

    // ----------COMMITTEE----------
    'committeeMembersViewing',

    // ----------EVENTS----------
    'eventMembersViewing',

    // ----------ORGANISATIONS----------
    'onlyYourOrganisationSpecialFieldsViewing',

    'organisationEmployeeViewing',

    // ----------LOYALTY PROGRAM----------
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramOnlyYourProductRequestDeleting',

    // ----------USERS----------
    'onlyYourJobTitleFieldsEditing',

    'userChatButtonViewing',

    // ----------CURATOR----------
    'curatorButtonViewing',
  ],
  Spectator: [
    // ----------PAGE----------
    'pageAssociationViewing',
    'pageAssociationOrganisationsViewing',
    'pageNewsFeedViewing',
    'pageChatsViewing',
    'pageChatsInnerViewing',
    'pageChatPublicViewing',
    'pageCommitteesViewing',
    'pageSubCommitteesViewing',
    'pageEventsViewing',
    'pageInfoViewing',
    'pageOrganisationViewing',
    'pagePollsViewing',
    'pageNewsletterViewing',
    'pageProfileViewing',
    'pageSettingsViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',

    // ----------LOYALTY PROGRAM----------
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramOnlyYourProductRequestDeleting',
  ],
} as const;

export const DYNAMIC_PERMISSIONS: DynamicPermissionsType = {
  showAllUsersPhonesAndEmails: ['organisationEmployeePhoneFieldViewing', 'organisationEmployeeEmailFieldViewing'],
  showOnlyLoyaltyProgram: [
    'pageSettingsViewing',
    'pageSettingsNotificationsViewing',
    'pageLoyaltyViewing',
    'pageProfileViewing',

    'loyaltyProgramCreating',
    'loyaltyProgramEditing',
    'loyaltyProgramDeleting',
    'loyaltyProgramPublishing',
    'loyaltyProgramUnpublishing',
    'loyaltyProgramOwnProductsViewing',
    'loyaltyProgramAllStatisticsViewing',
    'loyaltyProgramProductStatisticsViewing',
    'loyaltyProgramCollectionStatisticsViewing',
    'loyaltyProgramUnionListViewing',
    'loyaltyProgramProductCodesExport',
    'loyaltyProgramActiveCollectionsViewing',
    'loyaltyProgramCollectionsViewing',
    'loyaltyProgramCollectionEditing',
    'loyaltyProgramCollectionDeleting',
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestInfoViewing',
    'loyaltyProgramProductRequestEditing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramProductRequestDeleting',
    'loyaltyProgramOnlyYourProductRequestDeleting',

    'loyaltyProgramOnlyYourProductStatisticsViewing',
    'loyaltyProgramOnlyYourOrganisationProductEditing',
    'loyaltyProgramOnlyYourOrganisationProductUnpublishing',
    'loyaltyProgramOnlyYourOrganisationProductCodesExport',
  ],
  showBirthdaysNotificationsBanner: ['birthdaysNotificationsBannerViewing'],
  isMembersAllowedToPublishLocal: ['loyaltyProgramCreating'],
  isAdvertiserAssociation: [
    'loyaltyProgramProductStatisticsViewing',
    'loyaltyProgramOnlyYourProductStatisticsViewing',
    'loyaltyProgramCollectionsViewing',
    'loyaltyProgramCollectionStatisticsViewing',
    'loyaltyProgramProductRequestInfoViewing',
    'loyaltyProgramProductRequestEditing',
    'loyaltyProgramProductRequestDeleting',
  ],
  canRequestNewProducts: [
    'loyaltyProgramProductRequestViewing',
    'loyaltyProgramProductRequestInfoViewing',
    'loyaltyProgramProductRequestEditing',
    'loyaltyProgramProductRequestCommentsEditing',
    'loyaltyProgramProductRequestDeleting',
    'loyaltyProgramOnlyYourProductRequestDeleting',
  ],
  showCuratorButton: ['curatorButtonViewing'],
  isPartOfGlobalLoyaltyProgram: ['loyaltyProgramActiveCollectionsViewing'],
};
